<template>
<div>
  <SafeStore ref="safeStore" />

  <div>
    <h3>Safe Drops Summary Report</h3>

    <GenericDatePeriodSelector storeName="safeStore" />
    <GenericDaysSelector storeName="safeStore" />
    <!-- <DateSelectorTest /> -->

    <ExportToExcel 
      :tables="[
        'RCGB_SafeDrops', 'RMGB_SafeDrops', 'WGB_SafeDrops', 'SOG_SafeDrops', 'SOB_SafeDrops',
        'RCGB_Transactions', 'RMGB_Transactions', 'WGB_Transactions', 'SOG_Transactions', 'SOB_Transactions'
        ]" 
      bookName="Safe Drops Summary Report"
      storeName="safeStore"
    />

    <h3>RCGB</h3>
    <SafeDropsSummary location="RCGB" />
    <h3>RMGB</h3>
    <SafeDropsSummary location="RMGB" />
    <h3>WGB</h3>
    <SafeDropsSummary location="WGB" />
    <h3>SOG</h3>
    <SafeDropsSummary location="SOG" />
    <h3>SOB</h3>
    <SafeDropsSummary location="SOB" />
  </div>


</div>
</template>

<script>
import SafeStore from './Stores/SafeStore.vue'
import SafeDropsSummary from './Components/SafeDropsSummary.vue'
import formatDataMixin from '@/mixins/formatDataMixin.js'

export default {
  name: 'SafeDropSummaryReport',
  mixins : [formatDataMixin],
  components:{SafeDropsSummary,         SafeStore},
    provide() {
    return {
      safeDropsPage: this,
      page: this,
    }
  },
  computed:{
    // fuelStore(){ return this.$refs.fuelStore},
    timestamps(){ return this.$refs.fuelStore.timestamps},
  },

}
</script>

<style lang="scss" scoped>

</style>